import UpdateCompany from './UpdateCompany';
export default UpdateCompany;
